import * as React from "react";
import { Helmet } from "react-helmet";
import Box from "@mui/material/Box";
import collectionData from "./collection-data";
import CollectionCard from "components/collectioncard";
import BodyText from "components/bodytext";
import ContentBox from "components/contentbox";

import morphmarketlogo from "img/available/morphmarketlogo.png";
import YouTube from "img/site/yt_logo_rgb_dark.png";

const storeUrl = "https://www.morphmarket.com/stores/gregcooper669/#store-listings";
const youTubeUrl = "https://www.youtube.com/@gregcooperreptiles";


const CollectionGrid = () => {
  const markdown = `
  ## Intro
  I've been keeping snakes since the late 90's. Check out the
  collection using the **COLLECTION** link above. 
  I'm also doing updates on YouTube.
  
  *Enjoy the site!*
  `
  return (
    <>
    <ContentBox>
      <Helmet>
        <title>GCReptiles</title>
        <meta
          name="description"
          content="This is the home for Greg Cooper's reptile collection, home for many species of pythons, boas, and colubrids. From here you can navigate to any of the species of pythons, boas, or colubrids in the collection"
        />
        <link rel="canonical" href="https://www.gcreptiles.com/" />
      </Helmet>
      <BodyText>
        My name is Greg Cooper and I am a small-time reptile keeper 
        and breeder in Utah USA. I have been breeding boas, pythons, and
        colubrids since 1998. Browse below to see the species and animals that I keep.
      </BodyText>
      <BodyText>
        <img src={morphmarketlogo} height="25" alt="MorphMarket" />
        {" "}To see the animals that I have for sale, go to{" "}
        <a href={storeUrl} alt="MorphMarket">my store on MorphMarket</a>
      </BodyText>
      <BodyText>
        <a
          href={youTubeUrl}
          alt="GregCooperReptiles on YouTube"
          style={{ textDecorationLine: "none" }}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={YouTube} height="25" alt="YouTube" />
          {" "}GregCooperReptiles on YouTube
        </a>
      </BodyText>
      <BodyText>
        For feedback or more information please contact me at{" "}
        <a href="mailto:gregcooper669@gmail.com" alt="Mail gregcooper669@gmail.com" target="_top">
          gregcooper669@gmail.com
        </a>
      </BodyText>
      <Box
      sx={{
        margin: 2,
        display: "inline-flex",
        flexWrap: "wrap",
      }}
    >
      {collectionData.map((item) => (
        <CollectionCard
          key={item.id}
          id={item.id}
          title={item.species}
          smImg={item.smImg}
          mdImg={item.mdImg}
          sciName={item.sciName}
        />
      ))}
    </Box>
    </ContentBox>
    </>
  );
};

export default CollectionGrid;
